import { UnitInput } from "@/components/primitives/unit-input";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { calculateAlcoholComposition } from "@/lib/ingredients/form-estimators";
import { useEffect } from "react";
import { UseFormReturn } from "react-hook-form";
import { CreateIngredientFormData } from "./schema";
import { SimpleFormWrapper } from "./simple-wrapper";
export { calculateAlcoholComposition } from "@/lib/ingredients/form-estimators";

type SimpleFormProps = {
  form: UseFormReturn<CreateIngredientFormData>;
};

const ALCOHOL_DERIVED_FIELDS = [
  "waterPct",
  "energyKcal",
  "pac",
  "pod",
] as const;

// TODO: Implement alcohol composition calculations
export function SimpleAlcoholForm({ form }: SimpleFormProps) {
  const alcoholPctValue = form.watch("alcoholPct");

  useEffect(() => {
    const currentAlcoholPct = Number(alcoholPctValue);
    if (!isNaN(currentAlcoholPct)) {
      const calculated = calculateAlcoholComposition(currentAlcoholPct);
      for (const field of ALCOHOL_DERIVED_FIELDS) {
        form.setValue(field, calculated[field]);
      }
    }
  }, [alcoholPctValue, form]);

  return (
    <SimpleFormWrapper form={form} selectedCategory="alcohol">
      <FormField
        control={form.control}
        name="alcoholPct"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Alcohol %</FormLabel>
            <FormControl>
              <UnitInput {...field} unit="%" min={0} max={100} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </SimpleFormWrapper>
  );
}
